export default (data) => Object.keys(data)
  .map((key) => (data[key] ? `${key}=${data[key]}` : null))
  .filter(Boolean)
  .join('&');
